<app-view-entries
  [userFacilities]="filteredCapacityReports()"
  [facilitiesCount]="filteredCapacityReportsCount()"
  [page]="page()"
  [tab]="tab()"
  [perPageCount]="perPageCount()"
  [sort]="sort()"
  (pageChanged)="fetchCapacityReportsOnPageChange($event)"
  (tabChanged)="fetchCapacityReportsOnTabChange($event)"
  (perPageCountChanged)="fetchCapacityReportsOnPerPageCountChange($event)"
  (sortOrderChanged)="fetchCapacityReportsOnSortChange($event)"
  (drawerClosed)="drawerClosed()"
  (resetPerPageCount)="resetPerPageCount($event)"
></app-view-entries>
